namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPanelItemButtonEditor extends Serenity.Extensions.GridEditorBase<PsPanelItemButtonRow> {
        protected getColumnsKey() { return "InitialData.PsPanelItemButton"; }
        protected getDialogType() { return PsPanelItemButtonDialog; }
        protected getLocalTextPrefix() { return PsPanelItemButtonRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: number;
        public myPassValue2: string;
        
        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // if(this._appfg == false){
            buttons.push(
                {
                    title: Q.text("สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {

                       
                            // console.log(this.supid)
                            // console.log(this.supid +"sup" + this.whsid)
                            this.createEntityDialog(this.getItemType(), dlg => {


                                var dialog = dlg as PsPanelItemButtonDialog;
                                dialog.onSave = (opt, callback) => this.save(opt, callback);
                                var entity = this.getNewEntity() as PsPanelItemButtonRow;

                                entity.GroupButtonId = this.myPassValue;
                                entity.TouchPanelType = this.myPassValue2;
                                entity.ItemButtonId = this.totalamt;

                                dialog.loadEntityAndOpenDialog(entity, false);
                            }

                            );
                        }
                    },
                
            );
            buttons.push(
                {
                    title: Q.text("Refresh"),	// *** Get button text from translation
                    cssClass: 'button-refresh',
                    icon: 'fa-refresh',
                    onClick: () => {

                        this.refresh();
                    },
                }
            );

            // }

            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public totalamt: number;
        private _totals: number;
        public get TotalAmt_(): number { return this._totals; }

        set TotalAmt_(value: number) {
            this.totalamt = value
            var row = this.view.getRows();
            var i = 0;
            var sum = 0;
            for (var po of row) {
                i++;
                var id = po[this.getIdProperty()]
                var item = this.view?.getItemById?.(id)
                if (item) {
                    item.ItemButtonId = i;
                    this.view.updateItem(id, item)
                }
            }
        }

        // public totalamt: number;
        private _touchpanel: string;
        public get touchpanel(): string { return this._touchpanel; }

        set touchpanel(value: string) {
            console.log(value + " and " +this.touchpanel)
            // this.touchpanel = value
            var row = this.view.getRows();
            
            for (var po of row) {                
                var id = po[this.getIdProperty()]
                var item = this.view?.getItemById?.(id)
                if (item) {
                    item.TouchPanelType = value;
                    this.view.updateItem(id, item)
                }
            }
        }



        public clearDataGrid() {
            this.view.setItems([], true);
        }

    }
}
